import { FILTER_TYPE, FilterOption, FilterValueRange, SelectedFilter, SelectedFilterValue } from '@/components/filter-panel/filter-panel.types';

export const findSelectedFilter = (selectedFilters: SelectedFilter[], uuid: string): SelectedFilter | undefined => selectedFilters
  .find((selectedFilter: SelectedFilter) => selectedFilter.uuid === uuid);

export const removeSelectedFiltersFromDisabledFilters = (disabledFilters: FilterOption[], selectedFilters: SelectedFilter[]): FilterOption[] => (
  disabledFilters
    .filter((disabledFilter: FilterOption) => {
      const selectedFilter: SelectedFilter | undefined = findSelectedFilter(selectedFilters, disabledFilter.uuid);

      if (selectedFilter) {
        switch (selectedFilter.type) {
        case FILTER_TYPE.CHECKBOX_WITH_OPTIONS:
          return !selectedFilter.values.includes(disabledFilter.valueName);
        case FILTER_TYPE.MULTI_DATE_RANGE:
          return !selectedFilter.values.some((selectedFilterValue: SelectedFilterValue) => (
            `${(selectedFilterValue as FilterValueRange).min} - ${(selectedFilterValue as FilterValueRange).max}` === disabledFilter.valueName
          ));
        case FILTER_TYPE.DATE_RANGE:
        default:
          return false;
        }
      }
      return true;
    }));
